export class ChangePasswordModel {
    userId: any;
    oldpassword:any;
    password: any;
    flagWithlink:any;
}
